import React, { useState, useEffect, useContext, useMemo, useCallback } from 'react';
import RecommendedItem from '../Presentation/RecommendedItem';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { UserOrderContext } from 'context/context';
import { INDIA } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import { getValueOrDefaultObject, isEmptyEvery, isEmptyObject, ParseJsonSafely } from 'common/utilities/utils';

export const RecommendedContainer = props => {
  const { products, country, cssClass = '' } = props;
  const { userOrderState } = useContext(UserOrderContext);

  const checkIfStoreAvailable = () => {
    return getList(
      from,
      to,
      initialInterval,
      asap?.isAvailable,
      futureDates?.length === 1 && country?.toUpperCase() === INDIA,
      unavailibilities,
    );
  };
  const [isStoreClosed, setIsStoreClosed] = useState(false);
  const storeData = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem('currentStoreInfo'))
      : userOrderState.currentStoreInfo;
  }, [userOrderState.currentStoreInfo]);
  const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(storeData?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = startEndTime;
  const updateStoreStatusData = useCallback(() => {
    if (isEmptyObject(storeData)) {
      let storeStatus = storeData.summary?.status?.currentStatus;
      let availableSlots = checkIfStoreAvailable();
      if (storeStatus === 'CLOSED' && !availableSlots.length) {
        setIsStoreClosed(true);
      } else {
        setIsStoreClosed(false);
      }
    } else {
      setIsStoreClosed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeData]);

  useEffect(() => {
    updateStoreStatusData();
  }, [updateStoreStatusData]);
  return (
    <div className={`recommended-container ${cssClass}`} data-testid='recommended-container'>
      <RecommendedItem
        data-testid='recommended-items'
        products={products}
        storeClosedData={{ isStoreClosed }}
        {...props}
      />
    </div>
  );
};

export default RecommendedContainer;
